<template>
  <div class="terms__content">
    <h3>{{ $t('policy.list[0].title') }}</h3>

    <ol>
      <li>{{ $t('policy.list[0].clarification[0]') }}</li>
      <li>{{ $t('policy.list[0].clarification[1]') }}</li>
      <li><strong>{{ $t('policy.list[0].clarification[2]') }}</strong></li>
      <li>{{ $t('policy.list[0].clarification[3]') }}</li>
      <li>{{ $t('policy.list[0].clarification[4]') }}</li>
      <li>{{ $t('policy.list[0].clarification[5]') }}</li>
      <li>{{ $t('policy.list[0].clarification[6]') }}</li>
      <li>{{ $t('policy.list[0].clarification[6]') }}</li>
    </ol>

    <p>{{ $t('policy.list[0].text[0]') }}
      <a :href="'mailto:' + supportEmail">{{ supportEmail }}</a>.</p>

    <h3>{{ $t('policy.list[1].title') }}</h3>

    <h3>{{ $t('policy.list[1].subtitle') }}</h3>

    <p>{{ $t('policy.list[1].text[0]') }}</p>
    <p>{{ $t('policy.list[1].text[1]') }}</p>

    <ul>
      <li>{{ $t('policy.list[1].clarification[0]') }}</li>
      <li>{{ $t('policy.list[1].clarification[1]') }}</li>
      <li>{{ $t('policy.list[1].clarification[2]') }}</li>
    </ul>

    <p>{{ $t('policy.list[1].text[2]') }}</p>
    <p>{{ $t('policy.list[1].text[3]') }}</p>

    <h3>{{ $t('policy.list[2].title') }}</h3>
    <p>{{ $t('policy.list[2].text[0]') }}</p>

    <h3>{{ $t('policy.list[2].subtitle') }}</h3>

    <p>{{ $t('policy.list[2].text[1]') }}</p>
    <p>{{ $t('policy.list[2].text[2]') }}</p>
    <p>{{ $t('policy.list[2].text[3]') }}</p>
    <p>{{ $t('policy.list[2].text[4]') }}</p>
    <p>{{ $t('policy.list[2].text[5]') }}</p>
    <p>{{ $t('policy.list[2].text[6]') }}</p>
    <p>{{ $t('policy.list[2].text[7]') }}</p>
    <p>
      {{ $t('policy.list[2].text[8]') }}
      <a :href="'mailto:' + supportEmail">{{ supportEmail }}</a>
      {{ $t('policy.list[2].text[9]') }}
    </p>

    <p>
      {{ $t('policy.list[2].text[10]') }}<br>
      {{ $t('policy.list[2].text[11]') }}
      <a :href="'mailto:' + supportEmail">{{ supportEmail }}</a><br>
      {{ $t('policy.list[2].text[12]') }}<br>
      {{ $t('policy.list[2].text[13]') }}<br>
      {{ $t('policy.list[2].text[14]') }}<br>
      {{ $t('policy.list[2].text[15]') }}<br>
      {{ $t('policy.list[2].text[16]') }}<br>
      {{ $t('policy.list[2].text[17]') }}
    </p>

    <p>{{ $t('policy.list[2].text[18]') }}</p>
  </div>
</template>

<script>
export default {
  name: "subscription-terms",
  data() {
    return {
      supportEmail: 'support@' + location.hostname,
    }
  },
}
</script>

<style scoped>

</style>
